/* AMO variant picker — coordinates standalone option blocks (amo-pd-option) on a
   non-wizard product page. Resolves the chosen variant from all selected options,
   updates the cart form's hidden id, the price block, and the add-to-cart state.
   Ignores wizard forms (those are driven by amo-steps.js). */
(function () {
  function fmtMoney(cents, format) {
    var value = (cents / 100);
    format = format || '${{amount}}';
    function withComma(n){ return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, withComma(value))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  function initForm(form) {
    if (form.__amoV) return;
    if (form.closest('amo-steps')) return;              // wizard handles its own variants
    var scope = form.closest('.amo-product') || document;
    var groups = Array.prototype.slice.call(scope.querySelectorAll('[data-amo-optgroup]'));
    var propGroups = Array.prototype.slice.call(scope.querySelectorAll('[data-amo-propgroup]'));
    if (!groups.length && !propGroups.length) return;
    form.__amoV = true;

    // ---- Property options (no variant): write properties[Name] into the form ----
    propGroups.forEach(function (g) {
      var name = g.getAttribute('data-amo-prop-name');
      var nameEl = g.querySelector('[data-amo-optname]');
      function setProp(val) {
        var field = 'properties[' + name + ']';
        var input = form.querySelector('input[name="' + field.replace(/"/g, '\\"') + '"]');
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = field; form.appendChild(input); }
        input.value = val;
        if (nameEl) nameEl.textContent = val;
        g.querySelectorAll('[data-amo-opt-value]').forEach(function (b) {
          b.classList.toggle('is-selected', b.getAttribute('data-amo-opt-value') === val);
        });
      }
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-amo-opt-value]');
        if (b) setProp(b.getAttribute('data-amo-opt-value'));
      });
      var first = g.querySelector('.is-selected [data-amo-opt-value], [data-amo-opt-value]');
      if (first) setProp(first.getAttribute('data-amo-opt-value'));
    });

    if (!groups.length) return;                         // property-only page, done
    var matrixEl = scope.querySelector('[data-amo-variants]') || document.querySelector('[data-amo-variants]');
    if (!matrixEl) return;
    var variants;
    try { variants = JSON.parse(matrixEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var money = matrixEl.getAttribute('data-money') || '${{amount}}';
    var idInput = form.querySelector('input[name="id"]');
    var atc = form.querySelector('[name="add"]');
    var priceTarget = scope.querySelector('[data-amo-price-target]') || document.querySelector('[data-amo-price-target]');

    var selected = {};
    var start = variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0]
      || variants.filter(function (v) { return v.available; })[0] || variants[0];
    if (start) start.options.forEach(function (o, i) { selected[i + 1] = o; });

    function resolve() {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return selected[i + 1] === undefined || selected[i + 1] === o; });
      })[0];
    }
    function available(pos, val) {
      return variants.some(function (v) {
        if (v.options[pos - 1] !== val) return false;
        return v.available && v.options.every(function (o, i) { return (i + 1) === pos || selected[i + 1] === undefined || selected[i + 1] === o; });
      });
    }
    function apply() {
      groups.forEach(function (g) {
        var pos = +g.getAttribute('data-option-position');
        var nameEl = g.querySelector('[data-amo-optname]');
        if (nameEl) nameEl.textContent = selected[pos] || '';
        g.querySelectorAll('[data-amo-opt-value]').forEach(function (b) {
          var val = b.getAttribute('data-amo-opt-value');
          b.classList.toggle('is-selected', selected[pos] === val);
          var soldout = !available(pos, val);
          b.classList.toggle('is-soldout', soldout);
        });
      });
      var v = resolve();
      if (!v) {
        // This option combination doesn't exist: block the add instead of silently keeping the previous variant.
        if (atc) {
          if (!atc.getAttribute('data-label')) atc.setAttribute('data-label', atc.textContent);
          atc.disabled = true;
          atc.textContent = 'Unavailable';
        }
        return;
      }
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (priceTarget) {
        var now = priceTarget.querySelector('.amo-price-now');
        if (now) now.textContent = fmtMoney(v.price, money);
        var was = priceTarget.querySelector('.amo-price-was');
        if (v.compare_at && v.compare_at > v.price) {
          if (!was) { was = document.createElement('s'); was.className = 'amo-price-was'; priceTarget.appendChild(document.createTextNode(' ')); priceTarget.appendChild(was); }
          was.textContent = fmtMoney(v.compare_at, money);
        } else if (was) { was.remove(); }
      }
      if (atc) {
        if (!atc.getAttribute('data-label')) atc.setAttribute('data-label', atc.textContent);
        atc.disabled = !v.available;
        atc.textContent = v.available ? (atc.getAttribute('data-label') || atc.textContent) : (atc.getAttribute('data-sold') || 'Sold out');
      }
    }

    groups.forEach(function (g) {
      var pos = +g.getAttribute('data-option-position');
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-amo-opt-value]');
        if (!b) return;
        selected[pos] = b.getAttribute('data-amo-opt-value');
        apply();
      });
    });
    apply();
  }

  function init() {
    document.querySelectorAll('form[data-type="add-to-cart-form"], form[action^="/cart/add"]').forEach(initForm);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
